import classNames from "classnames";
import { AthleteBioVariants } from "rivals/shared/interfaces/Athlete";
import { setData } from "rivals/shared/utils/qa";
import AthleteBio from "./AthleteBio";
import styles from "./CollegePlayerCard.module.scss";
import type { Props } from "./types";

export default function CollegePlayerCard({
  bioVariant,
  collegePlayer,
  data = "college-player-card"
}: Props): JSX.Element {
  const containerStyles = classNames(styles.cardContainer, {
    [styles.socialCardVariant]: bioVariant === AthleteBioVariants.SOCIAL_CARD
  });

  return (
    <div className={containerStyles} {...setData(data, "container")}>
      <AthleteBio
        bioVariant={bioVariant}
        collegePlayer={collegePlayer}
        data={data}
      />
    </div>
  );
}
